import {
  filterProjectActivity,
  type ProjectActivityFilter,
} from '@littlebird/ui-utils';
import { observer } from 'mobx-react-lite';
import { useMemo, useState } from 'react';

import { YStack } from '@/components/ui';

import { ProjectActivityToolbar } from './project-activity-toolbar';
import { useProjectSharedContent } from './project-shared-content.query';
import { ProjectSharedItemsList } from './project-shared-items-list';

export const ProjectActivityTab = observer(function ProjectActivityTab({
  projectId,
  currentUserId,
}: {
  projectId: string;
  currentUserId: number;
}) {
  const chats = useProjectSharedContent('chat', projectId);
  const meetings = useProjectSharedContent('meeting', projectId);
  const [filter, setFilter] = useState<ProjectActivityFilter>('all');
  const [search, setSearch] = useState('');

  const items = useMemo(
    () =>
      filterProjectActivity({
        items: [...chats.data, ...meetings.data],
        filter,
        search,
      }),
    [chats.data, meetings.data, filter, search]
  );

  const hasNextPage = chats.hasNextPage || meetings.hasNextPage;

  return (
    <YStack className="gap-3">
      <ProjectActivityToolbar
        search={search}
        onSearchChange={setSearch}
        filter={filter}
        onFilterChange={setFilter}
      />
      <ProjectSharedItemsList
        projectId={projectId}
        currentUserId={currentUserId}
        testIdPrefix="project-activity"
        emptyTitle="No chats or notes yet"
        emptyDescription="Start a new chat or meeting, or right-click an existing one in the sidebar to add it here."
        ownHref={(item) =>
          item.type === 'chat' ? `/chats/${item.id}` : `/meetings/${item.id}`
        }
        data={items}
        isLoading={chats.isLoading || meetings.isLoading}
        hasNextPage={hasNextPage}
        isFetchingNextPage={
          chats.isFetchingNextPage || meetings.isFetchingNextPage
        }
        fetchNextPage={() => {
          if (chats.hasNextPage) void chats.fetchNextPage();
          if (meetings.hasNextPage) void meetings.fetchNextPage();
        }}
      />
    </YStack>
  );
});
